/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { FunctionComponent } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { classes } from '@adobe-commerce/elsie/lib';
import '@/plp/components/SearchAlertMessage/SearchAlertMessage.css';
import { Icon, InLineAlert } from '@adobe-commerce/elsie/components';
import { Warning } from '@adobe-commerce/elsie/icons';

export interface SearchAlertMessageProps extends HTMLAttributes<HTMLDivElement> {
  alertMessage?: string;
}

export const SearchAlertMessage: FunctionComponent<SearchAlertMessageProps> = ({ alertMessage = '' }) => {
  return (
    <div className={classes(['product-discovery-search-alert-message__wrapper'])}>
      <div className="product-discovery-search-alert-message__content">
        <InLineAlert
          heading={alertMessage}
          type={'warning'}
          icon={<Icon source={Warning} size="24" />}
          onDismiss={undefined}
        />
      </div>
    </div>
  );
};
